import React, { useEffect, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
// config file

/**
 * !PLEASE DO NOT REMOVE THE BELOW FIELDS
 * !THESE FIELDS WILL BE REPLACED IN THE BACKEND AS PER REQUIREMENT
 * @Orders
 * @Orders
 * @orders
 * @[{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"productName","type":"text","placeholder":"Product Name","label":"Product Name","width":110,"addFormOrder":1,"editFormOrder":1,"header":"Product Name","derivedValue":"productName=productName=undefined","capitalizeTableText":true,"sortable":true,"id":"productName","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"productName","showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}},{"name":"description","type":"text","placeholder":"Description","label":"Description","width":"130px","addFormOrder":12,"editFormOrder":12,"header":"Description","derivedValue":"description=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"description","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"description","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"volume","type":"text","placeholder":"Volume","label":"Volume","width":"130px","addFormOrder":13,"editFormOrder":13,"header":"Volume","derivedValue":"volume=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"volume","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"volume","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"facilityName","type":"text","placeholder":"Facility Name","label":"Facility Name","width":"130px","addFormOrder":14,"editFormOrder":14,"header":"Facility Name","derivedValue":"facilityName=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"facilityName","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"facilityName","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"storageUnit","type":"text","placeholder":"StorageUnit","label":"StorageUnit","width":"130px","addFormOrder":15,"editFormOrder":15,"header":"StorageUnit","derivedValue":"storageUnit=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"storageUnit","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"storageUnit","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"quantity","type":"text","placeholder":"Quantity","label":"Quantity","width":"130px","addFormOrder":16,"editFormOrder":16,"header":"Quantity","derivedValue":"quantity=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"quantity","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"quantity","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"distributorEmail","type":"email","placeholder":"Distributor Email","label":"Distributor Email","width":"150px","addFormOrder":21,"editFormOrder":21,"header":"Distributor Email","derivedValue":"distributorEmail=distributorEmail=undefined","capitalizeTableText":false,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"distributorEmail","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"distributorEmail","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"staffEmail","type":"relateAutoComplete","placeholder":"Staff Email","label":"Staff Email","width":"150px","addFormOrder":7,"editFormOrder":7,"header":"Staff Email","derivedValue":"staffEmail=staffEmail=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"staffEmail","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":"facilityStaff","searchField":"email","fieldType":"relateAutoComplete","populteFields":[],"displayFields":[],"controllerName":"facilityStaff","searchApi":"facilitystaffs","isMultiple":false,"textAlign":"Center","show":true,"field":"staffEmail","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"orderInventory","type":"number","placeholder":"Order Inventory","label":"Order Inventory","width":"120px","addFormOrder":8,"editFormOrder":8,"header":"Order Inventory","derivedValue":"orderInventory=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"orderInventory","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":true,"field":"orderInventory","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"orderedBy","type":"text","placeholder":"Ordered By","label":"Ordered By","width":"130px","addFormOrder":9,"editFormOrder":9,"header":"Ordered By","derivedValue":"orderedBy=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"orderedBy","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"orderedBy","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"createdByName","type":"Text","placeholder":"Created By","label":"Created By","width":120,"header":"Created By","id":"createdByName","displayinlist":"true","globalSearchField":"false","controllerId":1001,"fieldType":"Text","textAlign":"Center","show":true,"field":"createdByName","mobile":true,"filter":true,"displayInSettings":true},{"name":"updatedByName","type":"Text","placeholder":"Updated By","label":"Updated By","width":120,"header":"Updated By","id":"updatedByName","displayinlist":"true","fieldType":"Text","textAlign":"Center","show":true,"filter":true,"field":"updatedByName","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true},{"name":"orderedOn","type":"date","placeholder":"Ordered On","label":"Ordered On","width":"130px","addFormOrder":18,"editFormOrder":18,"header":"Ordered On","derivedValue":"orderedOn=orderedOn=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"orderedOn","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","fieldType":"Date","textAlign":"Center","show":true,"field":"orderedOn","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"resendEmail","type":"text","placeholder":"Re-send Email","label":"Re-send Email","width":"130px","addFormOrder":19,"editFormOrder":19,"header":"Re-send Email","derivedValue":"resendEmail=resendEmail=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"resendEmail","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"resendEmail","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"fullfilledOn","type":"date","placeholder":"Fullfilled On","label":"Fullfilled On","width":"130px","addFormOrder":20,"editFormOrder":20,"header":"Fullfilled On","derivedValue":"fullfilledOn=fullfilledOn=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"fullfilledOn","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","fieldType":"Date","textAlign":"Center","show":true,"field":"fullfilledOn","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"InvoiceNumber","type":"number","placeholder":"Invoice Number","label":"Invoice Number","width":"120px","addFormOrder":22,"editFormOrder":22,"header":"Invoice Number","derivedValue":"InvoiceNumber=InvoiceNumber=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"InvoiceNumber","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":true,"field":"InvoiceNumber","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true},{"name":"numberOfItemsRecieved","type":"text","placeholder":"Number Of Items Recieved","label":"Number Of Items Recieved","width":"130px","addFormOrder":22,"editFormOrder":22,"header":"Number Of Items Recieved","derivedValue":"numberOfItemsRecieved=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"numberOfItemsRecieved","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"numberOfItemsRecieved","showOrHideFields":[],"mobile":true,"displayInSettings":true}]
 * @[{"name":"productName","type":"text","placeholder":"Product Name","label":"Product Name","width":110,"addFormOrder":1,"editFormOrder":1,"derivedValue":"productName=productName=undefined","capitalizeTableText":true,"sortable":true,"id":"productName","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"},"isAddFormHidden":true,"isEditFormHidden":false},{"name":"description","type":"text","placeholder":"Description","label":"Description","width":"130px","addFormOrder":12,"editFormOrder":12,"derivedValue":"description=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"description","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"volume","type":"text","placeholder":"Volume","label":"Volume","width":"130px","addFormOrder":13,"editFormOrder":13,"derivedValue":"volume=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"volume","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"facilityName","type":"text","placeholder":"Facility Name","label":"Facility Name","width":"130px","addFormOrder":14,"editFormOrder":14,"derivedValue":"facilityName=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"facilityName","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"storageUnit","type":"text","placeholder":"StorageUnit","label":"StorageUnit","width":"130px","addFormOrder":15,"editFormOrder":15,"derivedValue":"storageUnit=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"storageUnit","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"quantity","type":"text","placeholder":"Quantity","label":"Quantity","width":"130px","addFormOrder":16,"editFormOrder":16,"derivedValue":"quantity=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"quantity","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"distributorEmail","type":"email","placeholder":"Distributor Email","label":"Distributor Email","width":"150px","addFormOrder":21,"editFormOrder":21,"derivedValue":"distributorEmail=distributorEmail=undefined","capitalizeTableText":false,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"distributorEmail","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"staffEmail","type":"relateAutoComplete","placeholder":"Staff Email","label":"Staff Email","width":"150px","addFormOrder":7,"editFormOrder":7,"derivedValue":"staffEmail=staffEmail=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"staffEmail","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":"facilityStaff","searchField":"email","fieldType":"relateAutoComplete","populteFields":[],"displayFields":[],"controllerName":"facilityStaff","searchApi":"facilitystaffs","isMultiple":false,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":false},{"name":"orderInventory","type":"number","placeholder":"Order Inventory","label":"Order Inventory","width":"120px","addFormOrder":8,"editFormOrder":8,"derivedValue":"orderInventory=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"orderInventory","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":false},{"name":"orderedBy","type":"text","placeholder":"Ordered By","label":"Ordered By","width":"130px","addFormOrder":9,"editFormOrder":9,"derivedValue":"orderedBy=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"orderedBy","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":false},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"orderedOn","type":"date","placeholder":"Ordered On","label":"Ordered On","width":"130px","addFormOrder":18,"editFormOrder":18,"derivedValue":"orderedOn=orderedOn=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"orderedOn","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","fieldType":"Date","show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"resendEmail","type":"text","placeholder":"Re-send Email","label":"Re-send Email","width":"130px","addFormOrder":19,"editFormOrder":19,"derivedValue":"resendEmail=resendEmail=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"resendEmail","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"fullfilledOn","type":"date","placeholder":"Fullfilled On","label":"Fullfilled On","width":"130px","addFormOrder":20,"editFormOrder":20,"derivedValue":"fullfilledOn=fullfilledOn=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"fullfilledOn","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","fieldType":"Date","show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"InvoiceNumber","type":"number","placeholder":"Invoice Number","label":"Invoice Number","width":"120px","addFormOrder":22,"editFormOrder":22,"derivedValue":"InvoiceNumber=InvoiceNumber=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"InvoiceNumber","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":false},{"name":"numberOfItemsRecieved","type":"text","placeholder":"Number Of Items Recieved","label":"Number Of Items Recieved","width":"130px","addFormOrder":22,"editFormOrder":22,"derivedValue":"numberOfItemsRecieved=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"numberOfItemsRecieved","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":false}]
 * @
 * @
 * @
 *
 *
 *
 */

const Orders = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);
  let [tabType, setTabType] = useState('Orders List');
  const query = new URLSearchParams(location.search);
  const comapanyId = query.get('comapanyId');
  const storageUnitId = query.get('storageUnitId')
  const params = useParams();
  useEffect(() => {
    let screenPermissions = RolePermissions.screenPermissions("Orders");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
  }, []);

  const getDerivedStateFromProps = (props, state) => {
    let storeData = store.getState();
    let languageData =
      storeData &&
        storeData.settingsData &&
        storeData.settingsData.settings &&
        storeData.settingsData.settings.languageTranslation
        ? storeData.settingsData.settings.languageTranslation
        : "";
    return { languageData: languageData };
  };
  // componentDidMount = () => {
  //   //Screen permisions value can be edit,view, no view
  //   let screenPermissions = RolePermissions.screenPermissions('Test');
  //   if (screenPermissions) {
  //     this.setState({
  //       rolePermission: screenPermissions
  //     })
  //   }
  //   // this.getRoleListFromServer()
  // }
  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };

  let getTableFields = (tabType) => {
    let apiUrl = '';
    if (tabType == 'Orders List' || tabType == 'Placed Orders' || tabType == 'Fulfilled Orders') {
      // apiUrl = apiCalls.orders;
    }
    setTabType(tabType)
    let data = [];
    if (tabType == 'Orders List') {
      data = getOrdersFields();
    } else if (tabType == 'Placed Orders') {
      data = getPlacedOrdersTableFields();
    } else if (tabType == 'Fulfilled Orders') {
      data = getFulfilledOrdersTableFields();
    } else {
      data = getOrdersFields();
    }
    return data;

  };


  const getOrdersFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    let data = [
      {
        textAlign: "center",
        width: 47,
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "companyName",
        type: "relateAutoComplete",
        placeholder: "Company Name",
        label: "Company Name",
        width: "90px",
        addFormOrder: 1,
        editFormOrder: 1,
        header: "Company Name",
        derivedValue: "companyName=companyName=undefined",
        capitalizeTableText: false,
        sortable: false,
        id: "companyName",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        required: false,
        globalSearchField: "false",
        controllerId: "employee",
        searchField: "companyName",
        sortable: 'true',
        // fieldType: "relateAutoComplete",
        displayFields: [],
        controllerName: "employee",
        searchApi: "employees",
        textAlign: "Center",
        show: false,
        field: "companyName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "productName",
        type: "text",
        placeholder: "Product Name",
        label: "Product Name",
        width: "250px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Product Name",
        derivedValue: "productName=productName=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "productName",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        sortable: 'true',
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "productName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        // fieldType: "Link",
        // style: {
        //   color: "#0e4768",
        //   cursor: "pointer",
        //   textTransform: "capitalize",
        // },
      },
      {
        name: "description",
        type: "text",
        placeholder: "Description",
        label: "Description",
        width: "80px",
        addFormOrder: 8,
        editFormOrder: 8,
        header: "Description",
        derivedValue: "description=description=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "description",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        sortable: 'true',
        field: "description",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "volume",
        type: "text",
        placeholder: "Volume",
        label: "Volume",
        width: "80px",
        addFormOrder: 9,
        editFormOrder: 9,
        header: "Volume",
        derivedValue: "volume=volume=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "volume",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "volume",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "facilityName",
        type: "text",
        placeholder: "Facility Name",
        label: "Facility Name",
        width: "100px",
        addFormOrder: 10,
        editFormOrder: 10,
        header: "Facility Name",
        derivedValue: "facilityName=facilityName=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "facilityName",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        sortable: 'true',
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "facilityName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "storageUnit",
        type: "text",
        placeholder: "Storage Unit",
        label: "Storage Unit",
        width: "80px",
        addFormOrder: 11,
        editFormOrder: 11,
        header: "Storage Unit",
        derivedValue: "storageUnit=storageUnit=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "storageUnit",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        sortable: 'true',
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "storageUnitName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "quantity",
        type: "text",
        placeholder: "Quantity",
        label: "Quantity",
        width: "40px",
        addFormOrder: 12,
        editFormOrder: 12,
        header: "Quantity",
        derivedValue: "quantity=quantity=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "quantity",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "required",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "distributorEmail",
        type: "text",
        placeholder: "Distributor Email",
        label: "Distributor Email",
        width: "100px",
        addFormOrder: 13,
        editFormOrder: 13,
        header: "POC Email",
        derivedValue: "distributorEmail=distributorEmail=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "distributorEmail",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        sortable: 'true',
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "distributorEmail",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
    ];
    return data;
  };
  const getPlacedOrdersTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    let data = [

      {
        name: "companyName",
        type: "relateAutoComplete",
        placeholder: "Company Name",
        label: "Company Name",
        width: "90px",
        addFormOrder: 1,
        editFormOrder: 1,
        header: "Company Name",
        derivedValue: "companyName=companyName=undefined",
        capitalizeTableText: false,
        sortable: true,
        id: "companyName",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        required: false,
        globalSearchField: "false",
        controllerId: "employee",
        searchField: "companyName",
        // fieldType: "relateAutoComplete",
        displayFields: [],
        controllerName: "employee",
        searchApi: "employees",
        textAlign: "Center",
        show: false,
        field: "companyName",

        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "productName",
        type: "text",
        placeholder: "Product Name",
        label: "Product Name",
        width: "250px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Product Name",
        derivedValue: "productName=productName=undefined",
        capitalizeTableText: false,
        sortable: true,
        actions: [],
        actionsNumber: [],
        id: "productName",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,

        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "productName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        // fieldType: "Link",
        // style: {
        //   color: "#0e4768",
        //   cursor: "pointer",
        //   textTransform: "capitalize",
        // },
      },
      {
        name: "description",
        type: "text",
        placeholder: "Description",
        label: "Description",
        width: "80px",
        addFormOrder: 8,
        editFormOrder: 8,
        header: "Description",
        derivedValue: "description=description=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "description",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        sortable: true,
        field: "description",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "volume",
        type: "text",
        placeholder: "Volume",
        label: "Volume",
        width: "80px",
        addFormOrder: 9,
        editFormOrder: 9,
        header: "Volume",
        derivedValue: "volume=volume=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "volume",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "volume",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "facilityName",
        type: "text",
        placeholder: "Facility Name",
        label: "Facility Name",
        width: "100px",
        addFormOrder: 10,
        editFormOrder: 10,
        header: "Facility Name",
        derivedValue: "facilityName=facilityName=undefined",
        capitalizeTableText: false,
        sortable: true,
        actions: [],
        actionsNumber: [],
        id: "facilityName",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "facilityName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "storageUnit",
        type: "text",
        placeholder: "Storage Unit",
        label: "Storage Unit",
        width: "100px",
        addFormOrder: 11,
        editFormOrder: 11,
        header: "Storage Unit",
        derivedValue: "storageUnit=storageUnit=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "storageUnit",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        sortable: true,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "storageUnitName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "quantity",
        type: "text",
        placeholder: "Quantity",
        label: "Quantity",
        width: "40px",
        addFormOrder: 12,
        editFormOrder: 12,
        header: "Quantity",
        derivedValue: "quantity=quantity=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "quantity",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "required",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "created",
        type: "date",
        placeholder: "created",
        label: "Ordered On",
        width: "100px",
        addFormOrder: 12,
        editFormOrder: 12,
        header: "Ordered On",
        derivedValue: "created=quantity=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        dateFormat: "MM-DD-YYYY",
        field: "created",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "reSendEmail",
        type: "text",
        placeholder: "reSendEmail",
        label: "Re-Send Email",
        width: "100px",
        addFormOrder: 12,
        editFormOrder: 12,
        header: "Re-Send Email",
        derivedValue: "reSendEmail=quantity=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "reSendEmail",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "reSendEmail",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "distributorEmail",
        type: "text",
        placeholder: "Distributor Email",
        label: "Distributor Email",
        width: "110px",
        addFormOrder: 13,
        editFormOrder: 13,
        header: "POC Email",
        derivedValue: "distributorEmail=distributorEmail=undefined",
        capitalizeTableText: false,
        sortable: true,
        actions: [],
        actionsNumber: [],
        id: "distributorEmail",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "distributorEmail",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
    ];
    return data;
  };
  const getFulfilledOrdersTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    let data = [

      {
        name: "companyName",
        type: "relateAutoComplete",
        placeholder: "Company Name",
        label: "Company Name",
        width: "90px",
        addFormOrder: 1,
        editFormOrder: 1,
        header: "Company Name",
        derivedValue: "companyName=companyName=undefined",
        capitalizeTableText: false,
        sortable: true,
        id: "companyName",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        required: false,
        globalSearchField: "false",
        controllerId: "employee",
        searchField: "companyName",
        // fieldType: "relateAutoComplete",
        displayFields: [],
        controllerName: "employee",
        searchApi: "employees",
        textAlign: "Center",
        show: false,
        field: "companyName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "productName",
        type: "text",
        placeholder: "Product Name",
        label: "Product Name",
        width: "250px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Product Name",
        derivedValue: "productName=productName=undefined",
        capitalizeTableText: false,
        sortable: true,
        actions: [],
        actionsNumber: [],
        id: "productName",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "productName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        // fieldType: "Link",
        // style: {
        //   color: "#0e4768",
        //   cursor: "pointer",
        //   textTransform: "capitalize",
        // },
      },
      {
        name: "description",
        type: "text",
        placeholder: "Description",
        label: "Description",
        width: "80px",
        addFormOrder: 8,
        editFormOrder: 8,
        header: "Description",
        derivedValue: "description=description=undefined",
        capitalizeTableText: false,
        sortable: true,
        actions: [],
        actionsNumber: [],
        id: "description",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "description",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "volume",
        type: "text",
        placeholder: "Volume",
        label: "Volume",
        width: "40px",
        addFormOrder: 9,
        editFormOrder: 9,
        header: "Volume",
        derivedValue: "volume=volume=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "volume",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "volume",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "facilityName",
        type: "text",
        placeholder: "Facility Name",
        label: "Facility Name",
        width: "100px",
        addFormOrder: 10,
        editFormOrder: 10,
        header: "Facility Name",
        derivedValue: "facilityName=facilityName=undefined",
        capitalizeTableText: false,
        sortable: true,
        actions: [],
        actionsNumber: [],
        id: "facilityName",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "facilityName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "storageUnit",
        type: "text",
        placeholder: "Storage Unit",
        label: "Storage Unit",
        width: "100px",
        addFormOrder: 11,
        editFormOrder: 11,
        header: "Storage Unit",
        derivedValue: "storageUnit=storageUnit=undefined",
        capitalizeTableText: false,
        sortable: true,
        actions: [],
        actionsNumber: [],
        id: "storageUnit",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "storageUnitName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "quantity",
        type: "text",
        placeholder: "Quantity",
        label: "Quantity",
        width: "40px",
        addFormOrder: 12,
        editFormOrder: 12,
        header: "Quantity",
        derivedValue: "quantity=quantity=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "quantity",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "required",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "created",
        type: "text",
        placeholder: "created",
        label: "Fulfilled On",
        width: "100px",
        addFormOrder: 12,
        editFormOrder: 12,
        header: "Fulfilled On",
        derivedValue: "created=quantity=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        dateFormat: '"MM-DD-YYYY"',
        show: true,
        field: "created",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "distributorEmail",
        type: "text",
        placeholder: "Distributor Email",
        label: "Distributor Email",
        width: "100px",
        addFormOrder: 13,
        editFormOrder: 13,
        header: "POC Email",
        derivedValue: "distributorEmail=distributorEmail=undefined",
        capitalizeTableText: false,
        sortable: true,
        actions: [],
        actionsNumber: [],
        id: "distributorEmail",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "distributorEmail",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
    ];
    return data;
  };

  let getFormFields = (tabType) => {
    setTabType(tabType)
    let fields = [];
    if (tabType == 'Orders List') {
      fields = getOrdersListFormFields();
    } else if (tabType == 'Placed Orders') {
      fields = getPlacedOrdersFormFields();
    } else {
      fields = getOrdersListFormFields();
    }
    return fields;
  }

  const getOrdersListFormFields = () => {
    let statusTypes = [
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return [
      {
        name: "productName",
        type: "text",
        placeholder: "Product Name",
        label: "Product Name",
        width: 110,
        addFormOrder: 1,
        editFormOrder: 1,
        derivedValue: "productName=productName=undefined",
        capitalizeTableText: true,
        sortable: true,
        id: "productName",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: false,
        disable: true,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        // fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
        isAddFormHidden: true,
        isEditFormHidden: false,
      },
      {
        name: "distributorEmail",
        type: "text",
        placeholder: "Staff Email",
        label: "POC Email",
        width: 110,
        addFormOrder: 1,
        editFormOrder: 1,
        derivedValue: "distributorEmail=productName=undefined",
        capitalizeTableText: true,
        sortable: true,
        id: "distributorEmail",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: true,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
        isAddFormHidden: true,
        isEditFormHidden: false,
      },
      {
        name: "required",
        type: "text",
        placeholder: "Order Inventory",
        label: "Order Inventory",
        width: "120px",
        addFormOrder: 8,
        editFormOrder: 8,
        derivedValue: "required=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "required",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: true,
        isEditFormHidden: false,
      },
      {
        name: "orderedBy",
        type: "text",
        placeholder: "Ordered By",
        label: "Ordered By",
        width: "130px",
        addFormOrder: 9,
        editFormOrder: 9,
        derivedValue: "orderedBy=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        disable: true,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "orderedBy",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: true,
        isEditFormHidden: false,
      },

    ];
  };
  const getPlacedOrdersFormFields = () => {
    let statusTypes = [
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return [
      {
        name: "InvoiceNumber",
        type: "text",
        placeholder: "Invoice Number",
        label: "Invoice Number",
        width: "120px",
        addFormOrder: 22,
        editFormOrder: 22,
        derivedValue: "InvoiceNumber=InvoiceNumber=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "InvoiceNumber",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "numberOfItemsRecieved",
        type: "number",
        placeholder: "Number Of Items Recieved",
        label: "Number Of Items Recieved",
        width: "130px",
        addFormOrder: 22,
        editFormOrder: 22,
        derivedValue: "numberOfItemsRecieved=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "numberOfItemsRecieved",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
    ];
  };


  const submit = async (item) => {
    setIsOpenFormModal(true);
    // await this.formModalRef.getRowData(item, 'edit');
  };
  const getMobileTableFields = () => {
    let data = [
      {
        textAlign: "center",
        width: 47,
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "productName",
        type: "text",
        placeholder: "Product Name",
        label: "Product Name",
        width: 110,
        addFormOrder: 1,
        editFormOrder: 1,
        header: "Product Name",
        derivedValue: "productName=productName=undefined",
        capitalizeTableText: true,
        sortable: true,
        id: "productName",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "productName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
      },
      {
        name: "description",
        type: "text",
        placeholder: "Description",
        label: "Description",
        width: "130px",
        addFormOrder: 12,
        editFormOrder: 12,
        header: "Description",
        derivedValue: "description=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "description",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "description",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "volume",
        type: "text",
        placeholder: "Volume",
        label: "Volume",
        width: "130px",
        addFormOrder: 13,
        editFormOrder: 13,
        header: "Volume",
        derivedValue: "volume=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "volume",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "volume",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "facilityName",
        type: "text",
        placeholder: "Facility Name",
        label: "Facility Name",
        width: "130px",
        addFormOrder: 14,
        editFormOrder: 14,
        header: "Facility Name",
        derivedValue: "facilityName=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "facilityName",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "facilityName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "storageUnit",
        type: "text",
        placeholder: "StorageUnit",
        label: "StorageUnit",
        width: "130px",
        addFormOrder: 15,
        editFormOrder: 15,
        header: "StorageUnit",
        derivedValue: "storageUnit=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "storageUnit",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "storageUnit",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "quantity",
        type: "text",
        placeholder: "Quantity",
        label: "Quantity",
        width: "130px",
        addFormOrder: 16,
        editFormOrder: 16,
        header: "Quantity",
        derivedValue: "quantity=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "quantity",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "quantity",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "distributorEmail",
        type: "email",
        placeholder: "Distributor Email",
        label: "Distributor Email",
        width: "150px",
        addFormOrder: 21,
        editFormOrder: 21,
        header: "Distributor Email",
        derivedValue: "distributorEmail=distributorEmail=undefined",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "distributorEmail",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "distributorEmail",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "staffEmail",
        type: "relateAutoComplete",
        placeholder: "Staff Email",
        label: "Staff Email",
        width: "150px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Staff Email",
        derivedValue: "staffEmail=staffEmail=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "staffEmail",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: "facilityStaff",
        searchField: "email",
        fieldType: "relateAutoComplete",
        populteFields: [],
        displayFields: [],
        controllerName: "facilityStaff",
        searchApi: "facilitystaffs",
        isMultiple: false,
        textAlign: "Center",
        show: true,
        field: "staffEmail",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "orderInventory",
        type: "number",
        placeholder: "Order Inventory",
        label: "Order Inventory",
        width: "120px",
        addFormOrder: 8,
        editFormOrder: 8,
        header: "Order Inventory",
        derivedValue: "orderInventory=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "orderInventory",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "orderInventory",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "orderedBy",
        type: "text",
        placeholder: "Ordered By",
        label: "Ordered By",
        width: "130px",
        addFormOrder: 9,
        editFormOrder: 9,
        header: "Ordered By",
        derivedValue: "orderedBy=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "orderedBy",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "orderedBy",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "createdByName",
        type: "Text",
        placeholder: "Created By",
        label: "Created By",
        width: 120,
        header: "Created By",
        id: "createdByName",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: 1001,
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        field: "createdByName",
        mobile: true,
        filter: true,
        displayInSettings: true,
      },
      {
        name: "updatedByName",
        type: "Text",
        placeholder: "Updated By",
        label: "Updated By",
        width: 120,
        header: "Updated By",
        id: "updatedByName",
        displayinlist: "true",
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        filter: true,
        field: "updatedByName",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        header: "Created",
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: true,
        show: true,
        field: "created",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "updated",
        type: "date",
        placeholder: "Updated",
        label: "Updated",
        width: 90,
        header: "Updated",
        derivedValue: "updated=undefined",
        actions: [],
        actionsNumber: [],
        id: "updated",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: true,
        show: true,
        field: "updated",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "orderedOn",
        type: "date",
        placeholder: "Ordered On",
        label: "Ordered On",
        width: "130px",
        addFormOrder: 18,
        editFormOrder: 18,
        header: "Ordered On",
        derivedValue: "orderedOn=orderedOn=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "orderedOn",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        dateFormat: "DD-MM-YYYY",
        fieldType: "Date",
        textAlign: "Center",
        show: true,
        field: "orderedOn",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "resendEmail",
        type: "text",
        placeholder: "Re-send Email",
        label: "Re-send Email",
        width: "130px",
        addFormOrder: 19,
        editFormOrder: 19,
        header: "Re-send Email",
        derivedValue: "resendEmail=resendEmail=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "resendEmail",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "resendEmail",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "fullfilledOn",
        type: "date",
        placeholder: "Fullfilled On",
        label: "Fullfilled On",
        width: "130px",
        addFormOrder: 20,
        editFormOrder: 20,
        header: "Fullfilled On",
        derivedValue: "fullfilledOn=fullfilledOn=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "fullfilledOn",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        dateFormat: "DD-MM-YYYY",
        fieldType: "Date",
        textAlign: "Center",
        show: true,
        field: "fullfilledOn",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "InvoiceNumber",
        type: "number",
        placeholder: "Invoice Number",
        label: "Invoice Number",
        width: "120px",
        addFormOrder: 22,
        editFormOrder: 22,
        header: "Invoice Number",
        derivedValue: "InvoiceNumber=InvoiceNumber=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "InvoiceNumber",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "InvoiceNumber",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
      {
        name: "numberOfItemsRecieved",
        type: "text",
        placeholder: "Number Of Items Recieved",
        label: "Number Of Items Recieved",
        width: "130px",
        addFormOrder: 22,
        editFormOrder: 22,
        header: "Number Of Items Recieved",
        derivedValue: "numberOfItemsRecieved=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "numberOfItemsRecieved",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "numberOfItemsRecieved",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
    ];
    return data;
  };
  const closeFormModal = async () => {
    setIsOpenFormModal(false);
  };

  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    window.location.reload();

    // if (type == "submit") {
    // type == "submit"
    //   ?
    // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
    // }

    // : null;
  };

  const saveDataToServer = async (item, field, value) => {
    let body = item[0];
    body[field] = value;
    let userBody = Object.assign({}, body);
    // this.setState({
    //   isLoading: true
    // });
    if (body) {
      let method, apiUrl;
      method = "PUT";
      apiUrl = `${apiCalls["orders"]}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          // let sessionexpired = await localStorage.getItem('sessionexpired')
          // if (sessionexpired === "true") {
          //   await this.setState({ sessionExpiryModal: true })
          // }
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, "success");
          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, "error");
          }
          // this.setState({
          //   isLoading: false
          // });
        })
        .catch((err) => {
          return err;
        });
    } else {
      return;
    }
  };

  // submit = (item) => {
  //   let userBody = item;
  //   return fetch("POST", "orders/sendEmail", userBody)
  //     .then((response) => {
  //       if (response && response.respCode && response.respCode === 200) {
  //         this.datatableref.getDataFromServer(this.state.filterCriteria, "refresh");
  //         showToasterMessage(response.respMessage, "success");
  //       } else if (response && response.errorMessage) {
  //         showToasterMessage(response.errorMessage, "error");
  //       }
  //       this.setState({
  //         isLoading: false,
  //       });
  //     })
  //     .catch((err) => {
  //       return err;
  //     });
  // }


  return (
    <span>
      {
        <DataTables
          {...props}
          getTableFields={getTableFields}
          formFields={getFormFields}
          //
          editRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          deleteRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          viewRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          // globalSearch={'Display Name/Email'}
          // type='Orders'
          // apiUrl={apiCalls.Orders}
          // exportRequried={true}
          printRequried={false}
          // actionsTypes={[{
          //   'name': 'Delete',
          //   "options": [
          //     { 'label': 'Delete', 'value': 'Delete', 'show': true, "multiple": true, },
          //   ]
          // }, {
          //   'name': 'Submit',
          //   'action': this.submit,
          //   "options": [
          //     { 'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
          //   ]
          // }]}
          // actionsTypes={
          //   [
          //     {
          //       name: "Delete",
          //       options: [
          //         {
          //           label: "Delete",
          //           value: "Delete",
          //           show:
          //             rolePermission && rolePermission == "Edit" ? true : false,
          //           multiple: true,
          //         },
          //       ],
          //     },

          //     // {
          //     //   'name': 'Block',
          //     //   "options": [
          //     //     { 'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
          //     //   ]
          //     // },
          //     // {
          //     //   'name': 'ResetPassword',
          //     //   "options": [
          //     //     { 'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
          //     //   ]
          //     // },
          //     {
          //       'name': 'Submit',
          //       'action': this.submit,
          //       "options": [
          //         { 'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
          //       ]
          //     },
          //     // {
          //     //   name: "newModel",
          //     //   action: this.submit1,
          //     //   options: [
          //     //     { label: "newModel", value: "newModel", show: true, multiple: false }
          //     //   ]
          //     // }
          //   ]}
          // addRequried={insertAdd}
          // editRequired={true}
          // deleteRequired={true}
          // viewRequired={true}
          settingsRequired={false}
          filterRequired={false}
          gridRequried={false}
          refresh={true}
          getPagination={true}
          exportToCsv={true}
          tabType={tabType}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          setData={setData}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          // filterExtension={"type=unchecked"}
          sampleFilePath={filePath["orders"]}
          globalSearch={
            "Product Name / Email / Storage Unit"}
          type="Orders"
          routeTo={apiCalls["orders"]}
          displayViewOfForm="modal"
          sideFormLeftOrRight=""
          apiResponseKey={apiCalls["orders"].toLowerCase()}
          apiUrl={apiCalls["orders"]}
          selectedId={params.id}
          selectionMode={true}
          companyId={comapanyId}
          storageUnitId={storageUnitId}
        />
      }
      {isOpenFormModal ? (
        <FormModal
          // onRef={(ref) => (this.formModalRef = ref)}
          formType="edit"
          openFormModal={isOpenFormModal}
          formFields={formFields}
          tabType={tabType}

        />
      ) : null}
      {openNewUserModal ? (
        <NewUserModal
          openNewUserModal={openNewUserModal}
          cancelReset={cancelReset}
          item={item}
          newFormFields={newFormFields}
          recordId={item._id}
          entityType="orders"
          apiUrl={apiCalls["orders"]}
        />
      ) : null}
    </span>
  );
};

export default Orders;
